import React from "react";
import { cn } from "@/lib/utils";
import { inputCls } from "./ui";

const HOURS = Array.from({ length: 12 }, (_, i) => String(i + 1));
const MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, "0"));

export function TimeSelect({ value, onChange, id, testid }: { value: string; onChange: (v: string) => void; id?: string; testid: string }) {
  const m = value.match(/^(\d{1,2}):(\d{2}) (AM|PM)$/);
  const [h, mm, ap] = m ? [m[1], m[2], m[3]] : ["", "00", "PM"];
  const set = (nh: string, nm: string, nap: string) => onChange(nh ? `${nh}:${nm} ${nap}` : "");
  const cls = cn(inputCls, "px-3");
  return (
    <div className="grid grid-cols-3 gap-2" data-testid={testid}>
      <select id={id} aria-label="Hour" className={cls} value={h} onChange={(e) => set(e.target.value, mm, ap)} data-testid={`${testid}-hour`}>
        <option value="">Hour</option>
        {HOURS.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <select aria-label="Minute" className={cls} value={mm} onChange={(e) => set(h, e.target.value, ap)} data-testid={`${testid}-minute`}>
        {MINUTES.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <select aria-label="AM or PM" className={cls} value={ap} onChange={(e) => set(h, mm, e.target.value)} data-testid={`${testid}-ampm`}>
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
}
